import { useSelector, useDispatch } from 'react-redux';
import { logout as logoutAction } from '../store/authSlice';
import { logoutApi } from '../api/auth';
import { getRefreshToken } from '../utils/auth';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, loading, error } = useSelector((s) => s.auth);

  const logout = async () => {
    try {
      const refresh = getRefreshToken();
      if (refresh) await logoutApi(refresh);
    } catch {}
    dispatch(logoutAction());
  };

  return {
    user,
    isAuthenticated,
    loading,
    error,
    logout,
    isAdmin: user?.role === 'admin',
    isPublisher: user?.role === 'publisher',
    isEndUser: user?.role === 'end_user',
  };
};
